export default "__VITE_ASSET__IncUTtJw__"